(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("h0w1z", function(module, exports) {

$parcel$export(module.exports, "parallaxHandler", function () { return $c61b4718b077d872$export$54d5d12e977e48e6; });

var $lGVtm = parcelRequire("lGVtm");
var $dxivK = parcelRequire("dxivK");
const $c61b4718b077d872$export$54d5d12e977e48e6 = (element)=>{
    // const {
    //   top: t,
    //   left: l
    // } = element.getBoundingClientRect()
    // // Compute element position relative to the top of the document
    // const body = document.body;
    // const animationStartOffset = 50;
    // let scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
    // let clientTop = element.clientTop || body.clientTop || 0;
    // let elementTopPosition = t + scrollTop - clientTop;
    // // In case page is reloaded after having scrolled, adjust image scale accordingly
    // let scrollPosition = window.scrollY;
    // let scaleFactor = scrollPosition > elementTopPosition - animationStartOffset ? (scrollPosition - elementTopPosition) / 25 : 0
    // element.style.backgroundSize = 100 + scaleFactor + '%'
    // // On scroll, adjust image scale accordingly
    // window.addEventListener('scroll', () => {
    //   let scrollPosition = window.scrollY;
    //   let scaleFactor = scrollPosition > elementTopPosition - animationStartOffset ? (scrollPosition - elementTopPosition) / 25 : 0
    //   element.style.backgroundSize = 100 + scaleFactor + '%'
    // })
    const scrollOptions = {
        target: element,
        offset: [
            "50% end",
            "end start"
        ]
    };
    (0, $dxivK.scroll)((0, $lGVtm.animate)(element, {
        backgroundSize: [
            "100%",
            "150%"
        ]
    }), scrollOptions);
} /**
 * TODO: Stop animation after sufficient scrolling
 */ ;

});

parcelRegister("1BJop", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $12bc753290b100a8$export$f6e2535fb5126e54; });
const $12bc753290b100a8$export$f6e2535fb5126e54 = (value)=>typeof value === "function";

});

parcelRegister("jcurC", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8; });
function $dfa6c0f8dc3dbbd0$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

});

})();
//# sourceMappingURL=parallax.c11331a7.js.map
